import React, { useEffect, useRef, useState } from "react";
import classNames from "classnames";
import { Message, Modal, Button, Icon } from "semantic-ui-react";
import ActionButton from "../ActionButton/ActionButton";
import OrderInfo from "../OrderInfo/OrderInfo";
import RxAssistantInfo from "../RxAssistantInfo/RxAssistantInfo";
import TimerDisplay from "../TimerDisplay/TimerDisplay";
import InfoBarMessages from ".//InfoBarMessages";
import { ActionTypes, WorkstationTypes } from "./../../utils/Constants";
import "./InfoBar.css";
import { connect } from "react-redux";
import { setInfoBarHeight } from "../../lib/store/reducers/layoutHelperReducer";
import { PayloadWrapper } from "../../lib/store/types/PayloadWrapper";
import OperatorInputModal from "../OperatorInputModal/OperatorInputModal";
import { isAFrameMixed } from "../../utils/sortTypeUtil";
import { getWorkstationTypeString } from "../../utils/helpers/workstationHelper";
import {
  sendMaxxOrderFinished,
  setCurrentBoxSnoozed,
  setMaxxMode,
  setStationPaused,
  setWarehouseAlarm,
} from "../../lib/store/reducers/rxBoxModeReducer";
import { RxOrderInfo } from "./rxOrderInfo";

const InfoBar = (props) => {
  const container = useRef(null);
  const {
    shelfCallback,
    showCancelButton,
    waitingForDeliveryRequest,
    waitingForNewIPackBox,
    operatorInstruction,
    operatorID,
    isPartialDelivery,
    wasCancelled,
    cartContent,
    currentOrderNumber,
    currentSortBoxID,
    currentShelf,
    shippingMethod,
    weight,
    scannedWeight,
    nextAction,
    cartType,
    isAuto,
    noPackMessage,
    fromReview,
    fromAFrameControl,
    sortID,
    latestShipping,
    aFrameCompletionMode,
    isPaused,
    isSingle,
    sortType,
    workstationType,
    isScanIdValidationCancelSortboxRequired,
    aFrameControlStation,
    sortWorkstationType,
    allVerified,
    rxMode = false,
    verifyOperatorExternal = true,
    setVerifyOperatorCallback = null,
    nextCartShelf = "",
    rxAssistantOperators = [],
    cancelAssistantOperatorCallback = null,
    setAssistantOperatorCallback = null,
    shippingHasIDCheck = false,
    rxOrderSku = null,
    rxCheckSubsidy = false,
    rxAuto = false,
    stationPaused,
    orderInfo = null,
    cancelRXAutoOrder = null,
    rxAutoShowCancel = false,
    maxxMode = false,
    boxWeightModel = null,
    orderStatus,
    loopTeamleader = false,
    companyID = 1,
    prefillBags = 0,
  } = props;

  const [verifyOperator, setVerifyOperator] = useState(false);
  const [showAddRXAssistant, setShowAddRXAssistant] = useState(false);
  const [showCreateAlarmConfirmation, setShowCreateAlarmConfirmation] = useState(false);
  const prevProps = usePrevious({
    currentOrderNumber,
    showCancelButton,
    operatorInstruction,
    currentShelf,
    isPartialDelivery,
    wasCancelled,
    cartType,
  });

  const sortBoxCancelledCallback = (successCallback) => {
    setVerifyOperator(false);
    if (setVerifyOperatorCallback) setVerifyOperatorCallback(new PayloadWrapper(false));
    successCallback();
  };

  const operatorInput = (authOperatorID, successCallback, failureCallback) => {
    shelfCallback(
      false,
      authOperatorID,
      () => sortBoxCancelledCallback(successCallback),
      failureCallback
    );
  };

  const closeOperatorInputModal = () => {
    setVerifyOperator(false);
    if (setVerifyOperatorCallback) setVerifyOperatorCallback(new PayloadWrapper(false));
  };

  const onCancelSortBox = () => {
    if (rxAuto) {
      if (typeof cancelRXAutoOrder === "function") {
        props.cancelRXAutoOrder();
      }
    } else {
      if (props.cancelSortBoxAccess) {
        shelfCallback(false, null);
      } else {
        setVerifyOperator(true);
        if (setVerifyOperatorCallback) setVerifyOperatorCallback(new PayloadWrapper(true));
      }
    }
  };

  const onCreateWarehouseAlarm = () => {
    props.setWarehouseAlarm(); 
    setShowCreateAlarmConfirmation(false);
  };

  useEffect(() => {
    function passCurrentHeight() {
      props.setHeight(container.current.clientHeight);
    }
    if (container.current !== null && prevProps !== undefined) {
      if (
        prevProps.currentOrderNumber !== currentOrderNumber ||
        prevProps.showCancelButton !== showCancelButton ||
        prevProps.currentShelf !== currentShelf ||
        prevProps.isPartialDelivery !== isPartialDelivery ||
        prevProps.wasCancelled !== wasCancelled ||
        prevProps.cartType !== cartType ||
        prevProps.waitingForDeliveryRequest !== waitingForDeliveryRequest
      ) {
        passCurrentHeight();
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    currentOrderNumber,
    showCancelButton,
    waitingForDeliveryRequest,
    currentShelf,
    isPartialDelivery,
    wasCancelled,
  ]);

  let opMessage = operatorInstruction;

  if (noPackMessage && nextAction === ActionTypes.SCAN_ARTICLE) {
    opMessage = "packa order";
  }

  const isAFrameMixedSortType = isAFrameMixed(sortType);
  const cancelPossible =
    (!rxAuto &&
      ((isAFrameMixedSortType &&
        (workstationType === WorkstationTypes.AutoPackMixedSmall ||
          workstationType === WorkstationTypes.AutoPackWestMixedSmall)) ||
        !isAFrameMixedSortType)) ||
    rxAutoShowCancel;

  let classes = void 0;
  let aFrameControlStationType = "";
  if (fromAFrameControl) {
    classes = classNames({
      aFrameControlStationTypeInfo: true,
      typeOne: aFrameControlStation === 1 ? true : false,
      typeTwo: aFrameControlStation === 2 ? true : false,
      typeThree: aFrameControlStation === 3 ? true : false,
      typeTen: aFrameControlStation === 10 ? true : false,
    });

    aFrameControlStationType = "AFRAME ";
    switch (aFrameControlStation) {
      case 1:
        aFrameControlStationType += "(Nya)";
        break;
      case 2:
        aFrameControlStationType += "(Gamla)";
        break;
      case 3:
        aFrameControlStationType += "(Väst)";
        break;
      case 10:
        aFrameControlStationType = "AutoStore";
    }
  }
  const rxAutoDone =
    rxAuto &&
    orderInfo &&
    orderInfo.SortBoxes.length > 0 &&
    orderInfo.SortBoxes.every((x) => x.Done) && !orderInfo.SkuPutawayRequired;

  const showTimerAndOrderInfo = companyID === 4 && isAuto;
  
  const timerAndOrderClasses = classNames({
    flexRow: !showTimerAndOrderInfo,
    flexColumn: showTimerAndOrderInfo,
    spaceBetween: true,
  })

  return (
    <div className="InfoBarContainer" ref={container}>
      {fromAFrameControl && currentOrderNumber > 0 ? (
        <Message size="massive" className={classes} info>
          Kontrollstation - {aFrameControlStationType}
        </Message>
      ) : null}

      <Message
        size="massive"
        className="OperatorInstructionMessageSmall flexColumn spaceBetween"
        info
      >
        <InfoBarMessages
          noPackMessage={noPackMessage}
          waitingForDeliveryRequest={waitingForDeliveryRequest}
          waitingForNewIPackBox={waitingForNewIPackBox}
          nextAction={nextAction}
          operatorInstruction={opMessage}
          operatorID={operatorID}
          cartType={cartType}
          isPartialDelivery={isPartialDelivery}
          wasCancelled={wasCancelled}
          allVerified={allVerified}
          rxCheckSubsidy={rxCheckSubsidy}
          loopTeamleader={loopTeamleader}
        >
          <ActionButton
            onClick={onCancelSortBox}
            show={showCancelButton && isPaused && !isSingle && cancelPossible}
            color={rxAutoDone ? "green" : "red"}
            buttonText={rxAutoDone ? "GODKÄNN" : "AVBRYT"}
          ></ActionButton>
        </InfoBarMessages>
      </Message>
      {rxAuto && orderInfo !== null && <RxOrderInfo prefillBags={prefillBags} orderInfo={orderInfo}></RxOrderInfo>}
      {isAFrameMixedSortType && !rxAuto && (
        <Message
          style={{
            margin: "5px 0 0 0",
          }}
          size="huge"
          info
          className="OperatorInstructionMessageSmall flexColumn spaceBetween"
        >
          <div style={{ alignSelf: "center" }}>
            A-Frame {getWorkstationTypeString(sortWorkstationType)}
          </div>
        </Message>
      )}
      <div className={timerAndOrderClasses}>
        <TimerDisplay
          show={!fromReview && !fromAFrameControl && !rxMode}
          timer="boxtimer"
          trigger={currentSortBoxID}
          isAuto={isAuto}
          type={1}
        ></TimerDisplay>
        <OrderInfo
          flexGrow={fromReview || fromAFrameControl || rxMode || showTimerAndOrderInfo}
          isAuto={isAuto}
          currentOrderNumber={currentOrderNumber}
          currentSortBoxID={currentSortBoxID}
          currentCartShelf={currentShelf}
          shippingMethod={shippingMethod}
          weight={weight}
          scannedWeight={scannedWeight}
          cartContent={cartContent}
          fromAFrameControl={fromAFrameControl}
          sortID={sortID}
          showTimerAndOrderInfo={showTimerAndOrderInfo}
          latestShipping={latestShipping}
          showOrderNumber={fromAFrameControl || rxMode || showTimerAndOrderInfo}
          showWeight={(!fromAFrameControl || aFrameCompletionMode) && !rxMode || showTimerAndOrderInfo}
          isRxOrder={rxMode}
          nextCartShelf={nextCartShelf}
          shippingHasIDCheck={shippingHasIDCheck}
          sortType={sortType}
          rxOrderSku={rxOrderSku}
          rxAuto={rxAuto}
          orderInfo={orderInfo}
          boxWeightModel={boxWeightModel}
          orderStatus={orderStatus}
        />
      </div>
      {rxMode && rxAuto && (
        <ActionButton
          className="ActionButton"
          onClick={() => props.setStationPaused(stationPaused ? false : true)}
          show={true}
          color={stationPaused ? "green" : "yellow"}
          buttonText={stationPaused ? "ÖPPNA STATION" : "PAUSA STATION"}
        ></ActionButton>
      )}
      {rxMode &&
        rxAuto &&
        orderInfo !== null &&
        orderInfo.SortBoxes &&
        orderInfo.SortBoxes.filter((box) => !box.Snoozed).length > 1 && (
          <ActionButton
            className={"ActionButton"}
            onClick={() => props.setCurrentBoxSnoozed()}
            show={true}
            color="blue"
            buttonText={"SNOOZA PÅSE"}
          ></ActionButton>
        )}
      {rxMode &&
        false &&
        rxAuto &&
        orderInfo !== null &&
        orderInfo.SortBoxes &&
        orderInfo.SortBoxes.find((box) => box.SortBoxID === orderInfo.CurrentSortBoxID && !box.Done) && (
          <ActionButton
            className={"ActionButton"}
            onClick={() => props.setCurrentBoxSnoozed()}
            show={true}
            color="red"
            buttonText={"STRYK PÅSE"}
          ></ActionButton>
        )}
      {rxMode && rxAuto && orderInfo !== null && orderInfo.CurrentSortBoxID > 0 && !maxxMode && (
        <ActionButton
          className={"ActionButton"}
          onClick={() => props.setMaxxMode(true)}
          show={true}
          color="violet"
          buttonText={"EXPEDIERA I MAXX"}
        ></ActionButton>
      )}
      {rxMode && rxAuto && orderInfo !== null && orderInfo.CurrentSortBoxID > 0 && maxxMode && (
        <div className="flexRow spaceBetween flexMiddle">
          <ActionButton
            className={"ActionButton Sped"}
            onClick={() => props.sendMaxxOrderFinished()}
            show={true}
            color="green"
            buttonText={"EXPEDIERAD"}
          ></ActionButton>
          <ActionButton
            className={"ActionButton Sped CancelSped"}
            onClick={() => props.setMaxxMode(false)}
            show={true}
            color="teal"
            buttonText={"EJ EXPEDIERAD"}
          ></ActionButton>
        </div>
      )}
      {rxMode && rxAuto && ( 
                
        <Modal
          open={showCreateAlarmConfirmation}
          trigger={
            <ActionButton
              className="ActionButton"
              onClick={() => setShowCreateAlarmConfirmation(true)}
              show={true}
              color={"red"}
              buttonText={"Rapportera KÖ-FEL"}
              >          
            </ActionButton>
          }>
          <Modal.Header className="CreateWarehouseAlarmModal">
            Rapportera kö-fel
          </Modal.Header>
          <Modal.Content>
              <p>
                Är du säker på att du vill rapportera ett kö-fel? Detta kommer att skapa ett Larm i Logistiken.
              </p>
          </Modal.Content>
          <Modal.Actions>
            <Button color='red' onClick={() => setShowCreateAlarmConfirmation(false)}>
              <Icon name='remove' /> Nej
            </Button>
            <Button color='green' onClick={() => onCreateWarehouseAlarm()}>
              <Icon name='checkmark' /> Ja
            </Button>
          </Modal.Actions>
        </Modal>
                  
              
      )}
     
      {rxMode && !showAddRXAssistant && !rxAuto && (
        <ActionButton
          onClick={() => {
            setShowAddRXAssistant(true);
          }}
          show={true}
          color="teal"
          buttonText="ANGE ASSISTENT"
        ></ActionButton>
      )}
      {rxMode &&
        rxAssistantOperators.length > 0 &&
        rxAssistantOperators.map((rxAssistantOperator, index) => (
          <RxAssistantInfo
            assistantOperator={rxAssistantOperator}
            key={index}
            cancelAssistantOperator={cancelAssistantOperatorCallback}
            setAssistantOperator={setAssistantOperatorCallback}
          />
        ))}
      {rxMode && showAddRXAssistant && (
        <RxAssistantInfo
          assistantOperator={null}
          cancelAssistantOperator={null}
          setAssistantOperator={setAssistantOperatorCallback}
          closeDialogCallback={() => {
            setShowAddRXAssistant(false);
          }}
        />
      )}
      <ActionButton
        className="ActionButton"
        onClick={() => shelfCallback(true, null)}
        show={
          !wasCancelled &&
          showCancelButton &&
          (!isPaused || !cancelPossible) &&
          !isSingle &&
          !rxAuto
        }
        color="yellow"
        buttonText="SNOOZA"
      />
      <ActionButton
        className="ActionButton"
        onClick={onCancelSortBox}
        show={showCancelButton && isSingle && cancelPossible}
        color="red"
        buttonText="AVBRYT"
      ></ActionButton>
      {verifyOperator && verifyOperatorExternal && (
        <OperatorInputModal
          open={verifyOperator}
          submitCallback={operatorInput}
          onClose={closeOperatorInputModal}
          submitButtonText="GODKÄNN AVBRYT FACK"
          headerText="Avbryt fack"
          isScanIdValidationRequired={isScanIdValidationCancelSortboxRequired}
        />
      )}
    </div>
  );
};

const mapDispatchToProps = (dispatch) => {
  return {
    setHeight: (height) => dispatch(setInfoBarHeight(new PayloadWrapper(height))),
    setStationPaused: (pause) => dispatch(setStationPaused(new PayloadWrapper(pause))),
    setCurrentBoxSnoozed: () => dispatch(setCurrentBoxSnoozed()),
    setMaxxMode: (maxxMode) => dispatch(setMaxxMode(new PayloadWrapper(maxxMode))),
    sendMaxxOrderFinished: () => dispatch(sendMaxxOrderFinished()),
    setWarehouseAlarm: () => dispatch(setWarehouseAlarm())
  };
};

export default connect(null, mapDispatchToProps)(InfoBar);

function usePrevious(value) {
  const ref = useRef();
  useEffect(() => {
    ref.current = value;
  });
  return ref.current;
}
